import React from "react";
import { connect } from "react-redux";
import { Tooltip } from 'reactstrap';
import * as types from "../../constants/actionTypes";
import { Link } from "react-router-dom";
import ToggleSwitch from "../common/input/ToggleSwitch";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import SectionLoading from "../common/SectionLoading";
import SectionLoadingError from "../common/SectionLoadingError";
import { getFirstName } from "../../helpers/formatting";
import { debounce } from "lodash";

const generalNotification = "GeneralNotification";

class GeneralNotifications extends React.Component {
    constructor(props) {
        super(props);
        this.debounceSavePreference = debounce(this.props.savePreference, 600, { maxWait: 1200 });
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.state = {
            showToolTip: false,
            useEmail: false,
            useSms: false,
            emailChanging: false,
            smsChanging: false,
            phone: null,
            email: null
        };
    }

    componentDidMount() {
        this.setState({ preferenceAlreadySet: false });
        logUI("MBHWeb.UI.GeneralNotification.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate() {
        const { smsChanging, emailChanging, preferenceAlreadySet } = this.state;
        const { isPreferenceUpdated, notificationData } = this.props;
        const error = isPreferenceUpdated && isPreferenceUpdated.error ? isPreferenceUpdated.error : null;

        const notificationPreferenceData = notificationData && !notificationData.waiting && notificationData.response && notificationData.response.length > 0 ? notificationData.response : [];
        if (!preferenceAlreadySet) {
            for (let data of notificationPreferenceData) {
                if (data.EventName === generalNotification) {
                    const { UseEmail, UseSms, Phone, Email } = data;
                    this.setState({ preferenceAlreadySet: true, useEmail: UseEmail, useSms: UseSms, phone: Phone, email: Email });
                    break;
                }
            }
        }
        if (smsChanging && error) {
            this.setState({ smsChanging: false, useSms: !this.state.useSms });
        }
        else if (emailChanging && error) {
            this.setState({ emailChanging: false, useEmail: !this.state.useEmail });
        }
    }

    onEmailChange = (useEmail) => {
        const { userName } = this.props;
        const { useSms, push } = this.state;
        this.setState({ emailChanging: true, useEmail });
        this.debounceSavePreference(userName, useEmail, useSms, push, generalNotification);
    }

    onSmsChange = (useSms) => {
        const { userName } = this.props;
        const { useEmail, push } = this.state;
        this.setState({ smsChanging: true, useSms });
        this.debounceSavePreference(userName, useEmail, useSms, push, generalNotification);
    }

    formattedPhone = (phone) => {
        return `${phone.AreaCode}.${phone.PhoneNumber.substr(0, 3)}.${phone.PhoneNumber.substr(3)}`;
    }
    toggleTooltip() {
        this.setState(prevState => ({
            showToolTip: !prevState.showToolTip
        }));
    }

    render() {
        const { notificationData, isPreferenceUpdated, isProxyUser, currentUser } = this.props;
        const { useEmail, useSms, phone, email, showToolTip } = this.state;
        return (
            <div className="general-notifications">
                <div className={`row general-notifications-title`}>
                    <div className="col-12">
                        <h2 className="page-heading section-heading">General</h2>
                    </div>
                </div>
                {!isProxyUser ? typeof notificationData === 'undefined' || notificationData.waiting
                    ? <SectionLoading /> : notificationData.error
                        ? <SectionLoadingError message="We're sorry, we currently are unable to get your general notification preference." />
                        : <React.Fragment>
                            <div className="row">
                                <div className="col-12 list-item-col not-linked">
                                    <div className="row">
                                        <div className="col-12 col-md-6 col-lg-4 list-item-col__data">
                                            <div className="list-item-col__label">Mobile Phone: </div>
                                            <div className="list-item-col__info">{phone ? this.formattedPhone(phone) : 'None entered'}</div>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-4 list-item-col__data">
                                            <div className="list-item-col__label text_sentence_case">Email: </div>
                                            <div className="list-item-col__info">{email ? email : 'None entered'}</div>
                                        </div>
                                        <div className="col-12 col-lg-4 text-lg-right">
                                            <Link to="/demographics">Edit in your profile</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 list-item-col not-linked">
                                    <div className="row">
                                        <div className="col-12 col-lg-8 col-md-6">
                                            <div className="list-item-col__label">Messages <span className="icon-info" id="lbl-msg-gn" />
                                                <Tooltip className="notification-tool-tip" placement="top" isOpen={showToolTip} autohide={false} target="lbl-msg-gn" toggle={this.toggleTooltip}>
                                                    Be notified about the latest programs and services that may be of interest to you.
                                                    </Tooltip>
                                            </div>
                                        </div>
                                        <div className="col-6 col-lg-2 col-md-3 text-sm-right">
                                            <ToggleSwitch placeholder="TEXT" name="textNotifications"
                                                checked={useSms}
                                                onChange={checked => this.onSmsChange(checked)}
                                            />
                                        </div>
                                        <div className="col-6 col-lg-2 col-md-3 text-sm-right">
                                            <ToggleSwitch placeholder="EMAIL" name="emailNotifications"
                                                checked={useEmail}
                                                onChange={checked => this.onEmailChange(checked)}
                                            />
                                        </div>
                                        <div className="col-12">
                                            {isPreferenceUpdated &&
                                                <div>
                                                    {isPreferenceUpdated.waiting
                                                        ? <SectionLoading />
                                                        : isPreferenceUpdated.error
                                                            ? <SectionLoadingError message="We're sorry, we currently are unable to change your general notification preference." />
                                                            : isPreferenceUpdated.response && <span className="success-msg">Your change has been successfully saved.</span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 list-item-col not-linked">
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-3">
                                            <div className="list-item-col__label">Push</div>
                                        </div>
                                        <div className="col-12 col-sm-8 col-md-9 text-left text-sm-right">
                                            <div className="list-item-col__info">Manage in MyBSWHealth mobile app </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    : <div className="row">
                        <div className="col-12 not-linked">Manage your notifications for {currentUser.firstName ? currentUser.firstName : getFirstName(currentUser.displayName)} in your settings.</div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userName: state.domain.un,
        isPreferenceUpdated: state.common[types.GENERAL_NOTIFICATION_PREFERENCE_SAVE],
        notificationData: state.common[types.GET_USER_NOTIFICATION_PREFERENCE],
        isProxyUser: state.domain.ip,
        currentUser: state.memberships.currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        savePreference: (userName, useEmail, useSms, usePush, eventName) =>
            dispatch({ type: types.GENERAL_NOTIFICATION_PREFERENCE_SAVE, data: { userName, useEmail, useSms, usePush, eventName } })
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralNotifications);